"use client";

import { useV2Translation } from "@/lib/i18n/use-v2-translation";

export const Footer = () => {
  const { t } = useV2Translation();

  const cols = [
    {
      title: t.footer.practice,
      links: [
        "SaaS V2 Rebuilds",
        "Zero-Downtime Migration",
        "AI-Ready Architecture",
        "Admin Dashboards",
      ],
    },
    {
      title: t.footer.stack,
      links: [
        "Next.js · React",
        "Node.js · Postgres",
        "Supabase · Vector DB",
        "ClickUp · Sprints",
      ],
    },
    {
      title: t.footer.company,
      links: ["About", "Our Work", "Client Stories", "Diagnostic Call"],
    },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="bg-paper border-t border-line py-16 lg:py-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 mb-16">
          <div className="col-span-12 lg:col-span-5">
            <a href="#top" className="flex items-center gap-2 mb-6">
              <span className="inline-block w-2.5 h-2.5 bg-gold" />
              <span className="font-display text-3xl tracking-tight">
                L&eacute;man <span className="italic text-gold">IT</span>
              </span>
            </a>
            <p className="font-body text-ink/70 max-w-[42ch] leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#6b6860] mt-8">
              {t.footer.yearLabel}
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="col-span-6 lg:col-span-2">
              <p className="font-mono text-[10px] uppercase tracking-widest text-[#6b6860] mb-5">
                {c.title}
              </p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#booking"
                      className="font-body text-sm text-ink hover:text-gold transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-12 lg:col-span-1 flex lg:justify-end">
            <a
              href="#top"
              data-testid="footer-back-to-top"
              className="font-mono text-[10px] uppercase tracking-widest text-ink hover:text-gold transition-colors"
            >
              &uarr; Top
            </a>
          </div>
        </div>

        <div className="border-t border-line pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-[11px] text-[#6b6860]">
            {t.footer.copyright}
          </p>
          <div className="flex items-center gap-6 font-mono text-[11px] text-[#6b6860]">
            <a href="#" className="hover:text-gold">
              Privacy
            </a>
            <a href="#" className="hover:text-gold">
              Terms
            </a>
            <a href="#" className="hover:text-gold">
              GDPR &middot; HDS
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
